import React, { useState } from 'react';
import { Star, ChevronLeft, ChevronRight } from 'lucide-react';

const Reviews = () => {
  const reviews = [
    {
      image: "dog1.jpg",
      name: "Chaitanya",
      date: "March 2023",
      review: "Oscar loves these. When she gets tired he goes for a sleep and comes back to it. A good distraction for a single dog living in an elderly home.",
      rating: 5
    },
    {
      image: "dog2.jpg",
      name: "Pratyaksh",
      date: "April 2023",
      review: "At last a chew my dogs can't destroy in minutes",
      rating: 5
    },
    {
      image: "dog3.jpg",
      name: "shashi",
      date: "December 2024",
      review: "Oscar loves these. When she gets tired he goes for a sleep and comes back to it. A good distraction for a single dog living in an elderly home.",
      rating: 5
    }
  ];

  const [currentIndex, setCurrentIndex] = useState(1);
  const [direction, setDirection] = useState(0);

  const handlePrev = () => {
    setDirection(-1);
    setTimeout(() => {
      setCurrentIndex((prev) => (prev === 0 ? reviews.length - 1 : prev - 1));
      setDirection(0);
    }, 50);
  };

  const handleNext = () => {
    setDirection(1);
    setTimeout(() => {
      setCurrentIndex((prev) => (prev === reviews.length - 1 ? 0 : prev + 1));
      setDirection(0);
    }, 50);
  };

  const getPosition = (index) => {
    const diff = index - currentIndex;
    if (diff === 0) return 0; // center
    if (diff === 1 || diff === -(reviews.length - 1)) return 1; // right
    if (diff === -1 || diff === reviews.length - 1) return -1; // left
    return 2; // hidden
  };

  const StarRating = ({ count = 5 }) => (
    <div style={{ display: 'flex', gap: '0.3rem', justifyContent: 'center', marginBottom: '1rem' }}>
      {[...Array(count)].map((_, i) => (
        <Star
          key={i}
          size={24}
          fill="#F4E04D"
          stroke="#F4E04D"
          style={{ filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.1))' }}
        />
      ))}
    </div>
  );

  return (
    <div style={{ fontFamily: 'Arial, sans-serif' }}>
      {/* Reviews Section */}
      <section style={{
        background: '#C4AE9A',
        padding: '4rem 0 5rem',
        position: 'relative',
        overflow: 'hidden'
      }}>
        <div className="container">
          {/* Title */}
          <h2 style={{
            fontSize: 'clamp(3rem, 8vw, 6rem)',
            fontWeight: '700',
            color: '#fff',
            textAlign: 'center',
            marginBottom: '3rem',
            fontFamily: 'Brush Script MT, cursive',
            fontStyle: 'italic',
            textShadow: '2px 2px 4px rgba(0,0,0,0.1)'
          }}>
            Reviews
          </h2>

          {/* Carousel Container */}
          <div style={{ position: 'relative', padding: '0 60px' }}>
            {/* Previous Button */}
            <button
              onClick={handlePrev}
              style={{
                position: 'absolute',
                left: '0',
                top: '50%',
                transform: 'translateY(-50%)',
                background: 'rgba(255,255,255,0.3)',
                border: 'none',
                borderRadius: '50%',
                width: '50px',
                height: '50px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                zIndex: 10,
                transition: 'all 0.3s ease',
                backdropFilter: 'blur(10px)'
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.background = 'rgba(255,255,255,0.5)';
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.background = 'rgba(255,255,255,0.3)';
              }}
            >
              <ChevronLeft size={28} color="#fff" />
            </button>

            {/* Next Button */}
            <button
              onClick={handleNext}
              style={{
                position: 'absolute',
                right: '0',
                top: '50%',
                transform: 'translateY(-50%)',
                background: 'rgba(255,255,255,0.3)',
                border: 'none',
                borderRadius: '50%',
                width: '50px',
                height: '50px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                zIndex: 10,
                transition: 'all 0.3s ease',
                backdropFilter: 'blur(10px)'
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.background = 'rgba(255,255,255,0.5)';
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.background = 'rgba(255,255,255,0.3)';
              }}
            >
              <ChevronRight size={28} color="#fff" />
            </button>

            {/* Reviews Cards Container */}
            <div style={{
              position: 'relative',
              minHeight: '650px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              {reviews.map((review, index) => {
                const position = getPosition(index);
                const isCenter = position === 0;
                const isLeft = position === -1;
                const isRight = position === 1;
                const isHidden = position === 2;

                let translateX = '0%';
                if (isLeft) translateX = '-110%';
                if (isRight) translateX = '110%';
                if (isHidden) translateX = position > 0 ? '220%' : '-220%';

                const scale = isCenter ? 1 : 0.85;
                const opacity = isHidden ? 0 : (isCenter ? 1 : 0.6);
                const zIndex = isCenter ? 10 : 5;

                return (
                  <div
                    key={index}
                    style={{
                      position: 'absolute',
                      width: '380px',
                      transform: `translateX(${translateX}) scale(${scale})`,
                      opacity: opacity,
                      transition: 'all 0.7s cubic-bezier(0.4, 0, 0.2, 1)',
                      cursor: !isCenter ? 'pointer' : 'default',
                      zIndex: zIndex,
                      filter: !isCenter && !isHidden ? 'blur(1px)' : 'blur(0px)',
                      pointerEvents: isHidden ? 'none' : 'auto'
                    }}
                    onClick={() => {
                      if (isLeft) handlePrev();
                      if (isRight) handleNext();
                    }}
                  >
                    <div style={{
                      background: 'rgba(255, 255, 255, 0.15)',
                      backdropFilter: 'blur(10px)',
                      borderRadius: '30px',
                      padding: '2rem 1.5rem',
                      textAlign: 'center',
                      display: 'flex',
                      flexDirection: 'column',
                      boxShadow: isCenter ? '0 12px 40px rgba(0,0,0,0.2)' : '0 8px 32px rgba(0,0,0,0.1)',
                      border: '1px solid rgba(255,255,255,0.2)',
                      transition: 'all 0.7s cubic-bezier(0.4, 0, 0.2, 1)'
                    }}>
                      {/* Dog Image */}
                      <div style={{
                        width: isCenter ? '300px' : '260px',
                        height: isCenter ? '300px' : '260px',
                        margin: '0 auto 1.5rem',
                        borderRadius: '25px',
                        overflow: 'hidden',
                        background: '#f0f0f0',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        boxShadow: '0 8px 24px rgba(0,0,0,0.15)',
                        transition: 'all 0.7s cubic-bezier(0.4, 0, 0.2, 1)'
                      }}>
                        <div style={{
                          width: '100%',
                          height: '100%',
                          background: 'linear-gradient(135deg, #E8D5C4 0%, #D4C4B5 100%)',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          fontSize: isCenter ? '120px' : '100px',
                          transition: 'all 0.7s cubic-bezier(0.4, 0, 0.2, 1)'
                        }}>
                          🐕
                        </div>
                      </div>

                      {/* Star Rating */}
                      <div style={{ 
                        transition: 'all 0.7s cubic-bezier(0.4, 0, 0.2, 1)',
                        opacity: isCenter ? 1 : 0.7
                      }}>
                        <StarRating count={review.rating} />
                      </div>

                      {/* Review Text */}
                      <p style={{
                        fontSize: isCenter ? '1.1rem' : '0.95rem',
                        color: '#fff',
                        lineHeight: '1.6',
                        marginBottom: '1.5rem',
                        minHeight: '80px',
                        textShadow: '1px 1px 2px rgba(0,0,0,0.1)',
                        transition: 'all 0.7s cubic-bezier(0.4, 0, 0.2, 1)'
                      }}>
                        "{review.review}"
                      </p>

                      {/* Author Name */}
                      <div style={{
                        fontSize: '1.1rem',
                        fontWeight: '600',
                        color: '#fff',
                        marginBottom: '0.25rem',
                        textShadow: '1px 1px 2px rgba(0,0,0,0.1)',
                        transition: 'all 0.7s cubic-bezier(0.4, 0, 0.2, 1)'
                      }}>
                        {review.name}
                      </div>

                      {/* Date */}
                      <div style={{
                        fontSize: '0.9rem',
                        color: 'rgba(255,255,255,0.8)',
                        textShadow: '1px 1px 2px rgba(0,0,0,0.1)',
                        transition: 'all 0.7s cubic-bezier(0.4, 0, 0.2, 1)'
                      }}>
                        {review.date}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>

            {/* Carousel Indicators */}
            <div style={{
              display: 'flex',
              justifyContent: 'center',
              gap: '0.5rem',
              marginTop: '2rem'
            }}>
              {reviews.map((_, index) => (
                <button
                  key={index}
                  onClick={() => {
                    if (index !== currentIndex) {
                      setDirection(index > currentIndex ? 1 : -1);
                      setTimeout(() => {
                        setCurrentIndex(index);
                        setDirection(0);
                      }, 50);
                    }
                  }}
                  style={{
                    width: currentIndex === index ? '30px' : '10px',
                    height: '10px',
                    borderRadius: '5px',
                    border: 'none',
                    background: currentIndex === index ? '#fff' : 'rgba(255,255,255,0.4)',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease'
                  }}
                />
              ))}
            </div>
          </div>
        </div>

        {/* Decorative Elements */}
        <div style={{
          position: 'absolute',
          width: '200px',
          height: '200px',
          borderRadius: '50%',
          background: 'rgba(255,255,255,0.05)',
          top: '10%',
          left: '5%',
          zIndex: 0
        }}></div>
        <div style={{
          position: 'absolute',
          width: '150px',
          height: '150px',
          borderRadius: '50%',
          background: 'rgba(255,255,255,0.05)',
          bottom: '15%',
          right: '8%',
          zIndex: 0
        }}></div>
      </section>

      {/* Bootstrap CSS */}
      <link
        href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css"
        rel="stylesheet"
      />
    </div>
  );
}

export default Reviews;